export const legendPad = {
    beforeInit(chart) {
        const originalFit = chart.legend.fit;
        chart.legend.fit = function fit() {
            originalFit.bind(chart.legend)();
            this.height += 10;
        }
    }
}
export const legendOffsetPlugin = {
    id: 'legendOffsetPlugin',
    defaults: {
        offsetX: 0,
        offsetY: 0
    },
    afterUpdate(chart, args, pluginOptions) {
        const legend = chart.legend;
        if (!legend) return;

        const position = legend.options.position;
        if (position !== 'top' && position !== 'bottom') return;

        const chartWidth = chart.width;
        const legendWidth = legend.width;

        let offsetX = (chartWidth - legendWidth) / 2;

        offsetX += pluginOptions.offsetX || 0;

        const offsetY = pluginOptions.offsetY || 0;

        legend.left = offsetX;
        legend.right = offsetX + legendWidth;
        legend.top += offsetY;
        legend.bottom += offsetY;
    }
};

export const onResize = function (chart, size) {
    // Not every chart uses chartjs-plugin-datalabels - some draw their labels straight
    // onto the canvas and size the font themselves, so this config may be absent.
    const datalabels = chart.config.options.plugins.datalabels;
    if (size.width < 505) {
        const options = chart.config.options;
        if (!(options.indexAxis && (options.indexAxis === 'Y' || options.indexAxis === 'y'))) {
            chart.config.options.scales.y.ticks = { display: false };
        }
        if (datalabels?.font) datalabels.font.size = 10;
    } else {
        if (datalabels?.font) datalabels.font.size = 14;
    };
    chart.update();
}

export const onEthnicityResize = function (chart, size) {
    if (size.width < 505) {
        const options = chart.config.options;
        if (!(options.indexAxis && (options.indexAxis === 'Y' || options.indexAxis === 'y'))) {
            chart.config.options.scales.y.ticks = { display: false };
        }
        chart.config.options.plugins.datalabels.font.size = 10;
    } else {
        chart.config.options.plugins.datalabels.font.size = 11;
    }
    chart.update();
}

export const tooltipTitleFont = {
    family: '"Roboto", Arial, sans-serif',
    size: 16,
    weight: 500
}

export const datalabelFont = {
    size: 14,
    weight: 500,
}

export const legendFont = {
    family: '"Roboto", Arial, sans-serif',
    size: 16,
    weight: 500
}

export const legendConfig = {
    labels: {
        color: "black",
        font: {
            family: '"Roboto", Arial, sans-serif',
            size: 14,
            weight: 500
        }
    },
    title: {
        text: "Click to Show/Hide Items",
        display: true,
        font: {
            style: 'italic'
        }
    }
};
